import React from "react";
import "../styles/Vision.css";
function AboutUs() {
  return (
    <>
      <div id="about">
        <div className="about-us-desc">
          At Trouble Fixer, we are a forward-thinking firm specializing in
          construction and IT solutions. Our unique dual expertise enables us to
          provide innovative, sustainable construction services and cutting-edge
          IT solutions, including advanced software and complex website
          development. We prioritize quality, efficiency, and client
          satisfaction in every project. Our skilled team is dedicated to
          tackling complex challenges with customized solutions that drive
          success and growth. At Trouble Fixer, we ensure every project is
          executed with precision and excellence.
        </div>
        <div className="about-img">
          <h1>About Us</h1>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
